import { render, staticRenderFns } from "./CAAG1140.vue?vue&type=template&id=4fa6f8a2&scoped=true"
import script from "./CAAG1140Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1140Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1140.vue?vue&type=style&index=0&id=4fa6f8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6f8a2",
  null
  
)

export default component.exports